import { createSlice } from '@reduxjs/toolkit';

interface themeEditorSliceState {
    overrides: any;
    menu: any;
    settings: any;
}

export const themeEditorSlice = createSlice({
    name: 'themeEditor',
    initialState: {
        overrides: {},
        menu: {},
        settings: {},
    } as themeEditorSliceState,

    reducers: {
        setThemeOverrides: (state, action) => {
            state.overrides = action.payload;
        },
        setThemeMenuOverrides: (state, action) => {
            state.menu = action.payload;
        },
        setThemeSettingsOverrides: (state, action) => {
            state.settings = action.payload;
        },
        resetThemeEditor: (state) => {
            state.overrides = {};
            state.menu = {};
            state.settings = {};
        },
    },
});

export const { setThemeOverrides, setThemeMenuOverrides, setThemeSettingsOverrides, resetThemeEditor } =
    themeEditorSlice.actions;

export default themeEditorSlice.reducer;
